import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const SizeCategoryModal = ({ handleClose, sizeCategoryId, productId, isCentered = true }) => {
	const [name, setName] = useState('');
	const [error, setError] = useState('');
	const [sizeMappingList, setSizeMappingList] = useState([]);

	const handleNameChange = (e) => {
		setName(e.target.value);
	};

	const handleSizeMappingChange = (e, key) => {
		let mappingList = [...sizeMappingList];
		mappingList.map((item) => {
			if (item.standardSize === key) item.mappingSize = e.target.value;
		});
		setSizeMappingList(mappingList);
	};

	const fetchInitialData = () => {
		if (sizeCategoryId) {
			ApiClient.GET('getSizeCategory', sizeCategoryId)
				.then(({ data }) => {
					setName(data.name);
					setSizeMappingList(data.sizeMappingResponseList);
				})
				.catch(() => {
					toastError('Failed to load size data');
				});
		} else {
			ApiClient.GET('defaultSizeCategory')
				.then(({ data }) => {
					setSizeMappingList(data);
				})
				.catch(() => {
					toastError('Failed to load default size category');
				});
		}
	};

	const addSizeCategory = (apiKey, body) => {
		ApiClient.POST(apiKey, body)
			.then(({ data }) => {
				toastSuccess(data.message);
				handleClose();
			})
			.catch(() => {
				toastError('Failed to save size category');
			});
	};

	const editSizeCategory = (apikey, body) => {
		ApiClient.PUT(apikey, body, sizeCategoryId)
			.then(({ data }) => {
				toastSuccess(data.message);
				handleClose();
			})
			.catch(() => {
				toastError('Failed to save size category');
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		let apiKey = 'addSizeCategory';
		if (sizeCategoryId) apiKey = 'editSizeCategory';

		let body = { name, sizeMappingList, productId };
		let mappingWiseSizeList = sizeMappingList.filter((item) => 'mappingSize' in item);

		if (name === '') {
			setError('Size Format Required!');
			return false;
		}
		if (sizeCategoryId) {
			editSizeCategory(apiKey, body);
		} else {
			if (mappingWiseSizeList.length < 1) {
				setError('Minimum one size label required!');
				return false;
			}
			addSizeCategory(apiKey, body);
		}
	};

	useEffect(() => {
		fetchInitialData();
	}, [sizeCategoryId, productId]);

	return (
		<>
			<Modal show={true} onHide={handleClose} centered={isCentered} className="auto-width-popup">
				<div className="common-popup size-category-popup shadow-24dp">
					<Modal.Header closeButton>
						<Modal.Title>
							<h3 className="semibold-16 mb-0">
								{sizeCategoryId ? 'Edit size format' : 'Add new size format'}
							</h3>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										<div className="form-group">
											<label htmlFor="category-name">Size format name</label>
											<input
												type="text"
												autoComplete="off"
												id="category-name"
												value={name}
												onChange={handleNameChange}
											/>
											{error !== '' && <p className="error">{error}</p>}
										</div>
									</div>
									<div className="col-md-12">
										<div className="sizes-details-table">
											<p>Input one size in each row</p>
											<table className="table">
												<thead>
													<tr>
														<th>SL</th>
														<th>Size labels</th>
													</tr>
												</thead>
												<tbody>
													{sizeMappingList.map((item, index) => {
														return (
															<tr key={`size_mapping_${index}`}>
																<td>
																	<span>{index + 1}</span>
																</td>
																<td>
																	<span>
																		<input
																			type="text"
																			autoComplete="off"
																			value={item.mappingSize}
																			onChange={(e) =>
																				handleSizeMappingChange(
																					e,
																					item.standardSize
																				)
																			}
																		/>
																	</span>
																</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="common-popup-footer pt-0">
							<div className="footer-buttons text-right ">
								<button className="button outline size32" onClick={handleClose}>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={handleSubmit}>
									Save
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
};

export default SizeCategoryModal;
